import { gql } from "@apollo/client";

export const addBookToSchoolQuery = gql`
mutation addBookToSchool($bookId: String!, $schoolId: String!, $copyFromId: String) {
  addBookToSchool(bookId: $bookId, schoolId: $schoolId, copyFromId: $copyFromId) {
    success
  }
}
`;
